import React, { useState, useEffect } from "react";
import "./matchmeme.css";
import logo from "../../../assets/images/coinlogo.png";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import cancelbtn from "../../../assets/Task/cancelicon1.png";
import { useAudio } from "../../../Providers/AudioProvider";
import useUserInfo from "../../../Hooks/useUserInfo";

import matchmeme from "../../Task/Task";
import { userGameRewards } from "../../../apis/user";
import { logPageView } from "../../../components/analytics";

const cardsData = [
  {
    name: "doge",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/dodge.png",
    id: 1,
  },
  {
    name: "pepe",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/pepe.png",
    id: 2,
  },
  {
    name: "wif",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/wif.png",
    id: 3,
  },
  {
    name: "bonk",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/bonk.png",
    id: 4,
  },
  {
    name: "shibu",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/shiba.png",
    id: 5,
  },
  {
    name: "ton",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/ton.png",
    id: 6,
  },
  {
    name: "trump",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/trump.png",
    id: 7,
  },
  {
    name: "floki",
    img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/floki.png",
    id: 8,
  },
];

const MemoryGame = () => {
  const [cards, setCards] = useState([]);
  const { userDetails, updateUserInfo, updatewatchScreenInfo,watchScreen } = useUserInfo();
  const [selectedCards, setSelectedCards] = useState([]);
  const [matchedCards, setMatchedCards] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [gameStarted, setGameStarted] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isPlayed, setIsPlayed] = useState(false);
  const playClick = useAudio();
  const [wrongCards, setWrongCards] = useState([]);
  const IsPointsReached = watchScreen?.LoginMessage=="You have already reached the maximum rewards limit"?true:false;
  const userId = userDetails?.userDetails?.telegramId;
  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: matchmeme,
      currentComponentText: "matchmeme",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };


  useEffect(() => {
    logPageView("Matchmeme ", "Matchmeme Game");
  }, []);


  useEffect(() => {
    const shuffledCards = shuffleArray([...cardsData, ...cardsData]);
    setCards(shuffledCards);
  }, []);

  const shuffleArray = (array) => array.sort(() => Math.random() - 0.5);

  const today = new Date().toDateString();
  const handleApiResponse = async (points) => {
    try {
      const apiData = {
        gamePoints: points,
        gameType: "MatchMeme",
        chancesToPlayed:1,
      };
      const res = await userGameRewards(apiData); // Replace with your actual API call
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setShowPopup(true);
        setIsPlayed(true);
        localStorage.setItem(
          `playedStatus_${userId}`,
          JSON.stringify({ isPlayed: true, date: today })
        );
        setTimer(0);
        if (points == "2500" || points == "0") {
          setPopupType("gameover");
        } else {
          setPopupType("win");
        }
      }
      else {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };
  useEffect(() => {
    if (gameStarted && matchedCards.length === cards.length && !isPlayed) {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      handleApiResponse("5000");
    }
  }, [matchedCards, cards.length, gameStarted]);

  const handleCardClick = (index) => {
    if (!gameStarted) setGameStarted(true);
    if (
      isPaused ||
      selectedCards.includes(index) ||
      matchedCards.includes(index)
    )
      return;
    setSelectedCards((prev) => [...prev, index]);
  };

  useEffect(() => {
    // Get stored data from localStorage
    const storedData = JSON.parse(
      localStorage.getItem(`playedStatus_${userId}`)
    );
    const today = new Date().toDateString();

    // Check if the stored date matches today's date
    if (storedData?.date === today) {
      setIsPlayed(storedData.isPlayed);
    } else {
      // Reset if the date has changed
      setIsPlayed(false);
      localStorage.setItem(
        `playedStatus_${userId}`,
        JSON.stringify({ isPlayed: false, date: today })
      );
    }
  }, []);
  useEffect(() => {
    if (selectedCards.length === 2) {
      const [firstIndex, secondIndex] = selectedCards;

      if (cards[firstIndex].id === cards[secondIndex].id) {
        setMatchedCards((prev) => {
          const updated = [...prev, firstIndex, secondIndex];
          return updated;
        });
      } else {
        setWrongCards([firstIndex, secondIndex]); // Highlight wrong pair
        setIsPaused(true);
      }
      setTimeout(() => {
        setWrongCards([]);
        setSelectedCards([]);
        setIsPaused(false);
      }, 600);
    }
  }, [selectedCards, cards]);

  // API call and response handling

  useEffect(() => {
    if (!gameStarted) return;

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          if (matchedCards.length < cards.length && !isPlayed) {
            updateUserInfo((prev) => ({
              ...prev,
              isLoading: true,
            }));
            handleApiResponse(userDetails?.earlyUsersLimitReached ? "0" : "2500");
          }
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [gameStarted]);

  const resetGame = () => {
    const shuffledCards = shuffleArray([...cardsData, ...cardsData]);
    setCards(shuffledCards);
    setSelectedCards([]);
    setMatchedCards([]);
    setGameStarted(false);
    setTimer(20); // Reset timer
  };
  const closePopUp = () => {
    setShowPopup(false);
  };
  return (
    <div className="memory-game">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      <div>
        <h2 className="welcometextmeme">
          Meme coin <br />
          matching game
        </h2>
      </div>
      <div className="row displayflex">
        {!isPlayed && (
          <div className="col-6">
            <h3 className="timer-meme">TIME: {timer}s</h3>
          </div>
        )}
      </div>
      <div className="game-board">
        {cards.map((card, index) => (
          <Card
            key={index}
            card={card}
            isFlipped={
              !selectedCards.includes(index) && !matchedCards.includes(index)
            }
            onClick={() => handleCardClick(index)}
            isMatched={matchedCards.includes(index)} // Ensure this is passed
            isWrong={wrongCards.includes(index)} // Ensure wrongCards logic is passed
            disabled={isPlayed} // Disable cards if game ended or not started
          />
        ))}
      </div>
      <div className="row">
        <p className="rulestext">
          {isPlayed ? (
            "Come again tomorrow"
          ) : !IsPointsReached? (
            <>
              Match all meme coins in 60 sec for,&nbsp;
              <span className="mm-point">5,000!</span> <br />
              {!userDetails?.earlyUsersLimitReached && (
                <>Missed it? You still get <span className="mm-point">2,500!</span></>
              )}
            </>
          ):''}
        </p>
      </div>

      {showPopup && !IsPointsReached &&  (
        <div className="overlay">
          <div className="popup">
            <div className="popup-content">
              <h2 className="epic2">
                {popupType === "win" ? "EPIC WIN!" : "GAME OVER"}
              </h2>

              <img
                src='https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png'
                className="cancel-img"
                onClick={closePopUp}
              />
              <div className="row text-center">
                <div className="col-12">
                  <div className="epic-div">
                    <p className="pointsLabel">
                      {popupType === "win" ? "TOKENS EARNED" : "TOKENS EARNED"}
                    </p>
                    {popupType === "win" ? (
                      <div className="pointsValue1">
                        <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' alt="logo" />
                        <p className="pointsNumber">5000</p>
                      </div>
                    ) : (
                      <div className="pointsValue1">
                        <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' alt="logo" />
                        <p className="pointsNumber">{userDetails?.earlyUsersLimitReached ? "0" : "2500"}</p>
                      </div>
                    )}
                  </div>
                  <p className="bottom-text">
                    {popupType === "win"
                      ? "Play daily to boost your score and rack up more points!"
                      : "Play daily to boost your score and rack up more points!"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
       {showPopup && IsPointsReached && (
        <div className="overlay">
          <div className="popup">
            <div className="popup-content">
              <h2 className="epic2">
                {"GAME OVER"}
              </h2>

              <img
                src='https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png'
                className="cancel-img"
                onClick={closePopUp}
              />
              <div className="row text-center">
                <div className="col-12">
                  <div className="epic-div">
                    <p className="pointsLabel" style={{ 
                      fontSize: '24px', 
                      fontWeight: 'bold', 
                      margin: '20px 0',
                      textAlign: 'center'
                    }}>
                      {matchedCards.length === cards.length ? "YOU WON!" : "YOU LOST!"}
                    </p>
                    {/* <div className="pointsValue1">
                      <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' alt="logo" />
                      <p className="pointsNumber">0</p>
                    </div> */}
                  </div>
                  <p className="bottom-text">
                    Great job! 🎭 You've played your limit for today — come back tomorrow for more memes! 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Card = ({ card, isFlipped, onClick, isWrong, isMatched, disabled }) => {
  // const cardClass = isMatched ? "correct" : isWrong ? "wrong" : "neutral";
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <div
      style={{
        width: "65px",
        height: "65px",
      }}
      className={`card ${isMatched ? "correct" : isWrong ? "wrong" : ""} ${
        isFlipped ? "flipped" : ""
      }`}
      onClick={handleClick}
    >
      <div className="card-innermeme">
        <div className="card-frontmeme">
          <img className="memeimg" src={card.img} alt={card.name} />
        </div>
        <div className="card-backmeme">
          <img
            src='https://d1ccopf5cw1hft.cloudfront.net/s3data/memeory-hide.svg'
            alt="Back"
          />
        </div>
      </div>
    </div>
  );
};

export default MemoryGame;
